import ApiService from '../service/ApiService'

export const isApiSuccess = (response) =>
  response?.success === 1 || response?.success === '1'

export const getCouponCodeForValidation = (coupon) =>
  coupon?.appliedCode || coupon?.couponName || ''

export const validateCouponCode = async (code, subTotal) => {
  const trimmed = String(code || '').trim()
  if (!trimmed) return null

  const endpoint = `/coupons/${encodeURIComponent(trimmed)}`
  const response = await ApiService(endpoint, { sub_total: subTotal }, 'GET')
  if (!isApiSuccess(response) || response?.data?.coupon_id == null) {
    return null
  }

  return {
    couponId: response.data.coupon_id,
    discountAmount: response.data.discount_amount,
    couponName: response.data.code || trimmed,
    appliedCode: trimmed,
  }
}

export const getCartSubTotal = (cart) => {
  if (!cart?.length) return 0
  if (cart.length === 1) return cart[0].price * cart[0].count
  return cart.reduce(
    (prev, next) => (prev?.count * prev?.price || prev) + next.count * next.price
  )
}

export const getAppliedCouponDiscount = (orderDetail, subTotal = 0) => {
  const coupon = orderDetail?.coupon
  if (!coupon) return 0

  const amount = coupon.discountAmount
  if (amount != null && amount !== '') {
    const n = Number(amount)
    return Number.isNaN(n) ? 0 : n
  }

  if (coupon.couponAmount == null) return 0
  if (coupon.couponType === 'percent') {
    return (Number(coupon.couponAmount) * subTotal) / 100
  }
  return Number(coupon.couponAmount) || 0
}
